import { render } from "./CollectionToolbar.vue?vue&type=template&id=553fe295&scoped=true"
import script from "./CollectionToolbar.vue?vue&type=script&lang=js"
export * from "./CollectionToolbar.vue?vue&type=script&lang=js"

import "./CollectionToolbar.vue?vue&type=style&index=0&id=553fe295&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553fe295"]])

export default __exports__